import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Box,
  Button,
  Grid,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createMultipleCabinsThunk } from "store/reducers/vending";
import * as yup from "yup";

const validation = yup.object({
  count: yup
    .number("Enter total number of cabins in this machine")
    .required("Username required")
    .positive()
    .min(1),
});

const CabinCreateInWizardForm = ({
  handleNext,
  handleSkip,
  machine,
  fullGrid = false,
}) => {
  const isFullWidth = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const vendingState = useSelector((state) => state.vending);
  const dispatch = useDispatch();
  useEffect(() => {
    if (vendingState.createMultipleCabinSuccess) {
      if (handleNext) {
        handleNext();
      }
    }
  }, [vendingState.createMultipleCabinSuccess]);
  const formik = useFormik({
    initialValues: {
      count: 1,
    },
    validationSchema: validation,
    onSubmit: (data) => {
      data["machine"] = machine.id;
      console.log(data);

      dispatch(createMultipleCabinsThunk(data));
    },
  });

  return (
    <Box sx={{ mb: 2 }}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container columnSpacing={2} rowSpacing={0}>
          <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
            <Box display="flex" flexDirection="column">
              <TextField
                label="Enter cabin count"
                variant="outlined"
                name="count"
                type="number"
                fullWidth
                sx={{ mt: 3 }}
                value={formik.values.count}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.count)}
                helperText={formik.errors.count}
                autoComplete="new-password"
                required
              />
            </Box>
            {vendingState.createMultipleCabinError && (
              <Alert sx={{ mt: 3 }} severity="error">
                Error occurred
              </Alert>
            )}
            {vendingState.createMultipleCabinSuccess && (
              <Alert sx={{ mt: 3 }} severity="success">
                Success
              </Alert>
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "center",
                marginTop: 3,
              }}
            >
              <LoadingButton
                loading={vendingState.createMultipleCabinLoading}
                variant="contained"
                fullWidth={isFullWidth}
                type="submit"
              >
                {fullGrid ? "Add" : "Continue"}
              </LoadingButton>
              {!fullGrid && (
                <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                  Skip
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default CabinCreateInWizardForm;
